// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__8zVo0","alertIcon":"ConfirmModal_alertIcon__1ROyc"};